import { motion } from "framer-motion";

import SectionHeading from "@/components/SectionHeading";
import SmartLink from "@/components/SmartLink";
import { Button } from "@/components/ui/button";

export default function WorkshopsListSection({ content, dataTestId, className = "" }) {
  return (
    <section className={`py-16 md:py-24 ${className}`.trim()} data-testid={dataTestId}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <SectionHeading title={content.title} description={content.description} />
        </motion.div>
        <div className="grid grid-cols-1 gap-6">
          {content.cards.map((card, index) => (
            <motion.div
              key={card.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-card rounded-3xl p-8 md:p-10 shadow-soft border border-border"
            >
              {card.status ? (
                <span className="inline-block px-3 py-1 rounded-full bg-secondary/36 text-highlight font-body text-sm font-medium mb-4 border border-secondary/45">
                  {card.status}
                </span>
              ) : null}
              <h3 className="font-sans text-2xl md:text-3xl font-semibold text-foreground mb-3">{card.title}</h3>
              <p className="font-body text-muted-foreground leading-relaxed mb-6">{card.description}</p>
              {card.details?.length ? (
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
                  {card.details.map((detail) => (
                    <li key={detail} className="font-body text-foreground/90 bg-muted/90 rounded-2xl px-4 py-3 border border-border/70">
                      {detail}
                    </li>
                  ))}
                </ul>
              ) : null}
              <Button asChild size="lg" className="rounded-full bg-primary hover:bg-primary/90 text-white font-medium px-8 btn-hover">
                <SmartLink href={card.cta.href} external={card.cta.external}>
                  {card.cta.label}
                </SmartLink>
              </Button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
